/** Miroir de backend/src/diagrams/version-label.util.ts — sert uniquement à prévisualiser la prochaine lettre dans la confirmation avant création (voir DiagramPage.handleCreateVersion), l'étiquette réelle est toujours calculée côté serveur. */
export function nextVersionLabel(existingCount: number): string {
  let n = existingCount + 1;
  let label = '';
  while (n > 0) {
    const remainder = (n - 1) % 26;
    label = String.fromCharCode(65 + remainder) + label;
    n = Math.floor((n - 1) / 26);
  }
  return label;
}
